<header class="fixed-top align-item-center justify-content-center">
  <div class="topbar d-flex align-items-center">
    <div
      class="container-fluid d-flex justify-content-center justify-content-md-between py-2 px-md-4"
    >
      <div class="contact-info d-none d-md-flex align-items-center">
        <div class="d-flex align-items-center ms-4">
          <i class="fas fa-envelope me-2"></i
          ><a href="mailto:info@vetaip.com">info&#64;vetaip.com</a>
        </div>
      </div>
      <div class="social-links d-flex align-items-center">
        <div class="d-flex align-items-center me-3">
          <!-- *ngIf="!authService" -->
          <a class="nav-link" [routerLink]="loginPath"> Login </a>
          <div class="vr vr-blurry mx-2"></div>
          <!-- *ngIf="!authService" -->
          <a class="nav-link" [routerLink]="registerPath"> Register </a>
        </div>
      </div>
    </div>
  </div>
  <!-- End Top Bar -->

  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid px-md-4">
      <a class="navbar-brand me-2" routerLink="">
        <img
          src="images/logo.png"
          alt="Logo"
          width="130"
          height="16"
          loading="lazy"
          style="margin-top: -1px"
        />
      </a>

      <button
        class="navbar-toggler"
        type="button"
        (click)="toggleNavbar()"
        [attr.aria-expanded]="isNavbarOpen"
        aria-label="Toggle navigation"
      >
        <i class="fas" [class.fa-bars]="!isNavbarOpen" [class.fa-times]="isNavbarOpen"></i>
      </button>

      <div
        id="navbarButtonsExample"
        class="navbar-collapse"
        [class.collapse]="!isNavbarOpen"
        [class.show]="isNavbarOpen"
      >
        <ul class="navbar-nav mx-auto ghap-2 mb-2 mb-lg-0">
          <li class="nav-item mx-md-2">
            <a
              class="nav-link"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              routerLink=""
              aria-current="/home"
              >Home</a
            >
          </li>
          <li class="nav-item mx-md-2">
            <a class="nav-link" routerLinkActive="active" routerLink="/who-we-are"
              >What is MATRIX</a
            >
          </li>
          <li class="nav-item mx-md-2">
            <a class="nav-link" routerLinkActive="active" routerLink="/ts">Timeseries</a>
          </li>
          <li class="nav-item mx-md-2">
            <a class="nav-link" routerLinkActive="active" routerLink="/contact">SM</a>
          </li>
        </ul>

        <div class="d-flex align-items-center">
          <button type="button" class="btn btn-primary" nzSize="small">TRADE</button>
        </div>
      </div>
    </div>
  </nav>
</header>
